import {
  AvailabilityRoute,
  ScheduleRoute,
  SearchRoute,
  EcommRoute,
  EntityManagementRoute,
  BookingRoute,
  ReportingRoute,
  CallsheetRoute,
  SkuCarryoverRoute,
  ClosetRoute
} from './index';

export default [
  ScheduleRoute,
  SearchRoute,
  AvailabilityRoute,
  EcommRoute,
  BookingRoute,
  CallsheetRoute,
  ReportingRoute,
  EntityManagementRoute,
  SkuCarryoverRoute,
  ClosetRoute,
];

